import axios from "axios";
import Constants from "../../utils/Constantes";

const API_URL = Constants.api_url;
const URL_BASE_VIDA_ADMIN = `${API_URL}/vidadm/`;

export async function getListaVidaAdmin() {
  return await axios({
    method: "GET",
    url: `${URL_BASE_VIDA_ADMIN}`,

  })
    .then((response) => response.data)
    .catch((response) => (response.data = "Error"));
}

export async function getDatosAdicionales(xsolactadm, signal) {
  return await axios({
    method: "GET",
    url: `${URL_BASE_VIDA_ADMIN}${xsolactadm}`,
    signal, // 👈 aquí pasamos el signal del AbortController
  })
    .then((response) => response.data)
    .catch((error) => {
      if (error.name === "CanceledError" || error.name === "AbortError") {
        // petición cancelada, no es un error real
        return null;
      }
      return "Error";
    });
}

export async function getResolucion(xsolactadm, signal) {
  return await axios({
    method: "GET",
    url: `${URL_BASE_VIDA_ADMIN}${xsolactadm}/resolucion`,
    responseType: "blob",
    signal, // 👈 soporte de cancelación
  })
    .then((response) => response.data)
    .catch((error) => {
      if (error.name === "CanceledError" || error.name === "AbortError") {
        return null; // cancelada, devolvemos null
      }
      return "Error";
    });
}